export const AttendanceTable = ({ records }) => (
  <div className="bg-white border border-stone-200 rounded-lg overflow-x-auto">
    <table className="w-full text-sm">
      <thead>
        <tr className="text-left text-xs uppercase tracking-wide text-stone-500 border-b border-stone-200">
          <th className="px-6 py-4">Employee</th><th className="px-6 py-4">In</th><th className="px-6 py-4">Out</th>
          <th className="px-6 py-4 text-right">Hours</th><th className="px-6 py-4 text-right">OT</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-stone-100">
        {records.length === 0 && <tr><td colSpan={5} className="px-6 py-10 text-center text-stone-400">No attendance records for this date.</td></tr>}
        {records.map((r) => (
          <tr key={r.id}>
            <td className="px-6 py-3">
              <span className="font-semibold">{r.employee_name}</span>
              <span className="text-xs text-stone-500 ml-2">{r.department}</span>
              {r.half_day && <span className="ml-2 px-2 py-0.5 rounded-full bg-purple-100 text-purple-800 text-[10px] font-bold">Half day</span>}
              {r.marked_by_admin && <span className="ml-2 px-2 py-0.5 rounded-full bg-amber-100 text-amber-800 text-[10px] font-bold" title={`Marked by ${r.marked_by_admin}`}>by HR</span>}
            </td>
            <td className="px-6 py-3 tabular-nums">{r.check_in || "—"}</td>
            <td className="px-6 py-3 tabular-nums">{r.check_out || "—"}</td>
            <td className="px-6 py-3 text-right tabular-nums">{r.hours ?? "—"}</td>
            <td className="px-6 py-3 text-right tabular-nums">{r.overtime_hours || 0}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
